// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Uo-z","badgeLink":"Vo-z","category":"Wo-z"};